import React, { ReactElement, useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import useRouting, { Link } from "../../../contexts/Routing";
import { useGetArticleTagsQuery, usePublishArticleMutation, useSaveArticleMutation } from "../../../__generated__/api";
import Avatar from "../../avatar/Avatar";
import Confirm from "../../confirm/Confirm";
import EditableControl, { ControlType } from "../../editable-text/EditableText";
import Editor from "../../editor/Editor";
import Select from "../../select/Select";
import Styles from "../Chat.module.scss";

const PUBLISH_OPTOIONS = [
    {
        label: "Publish Now",
        value: "publish",
        data: true,
    },
    {
        label: "Dont Publish",
        value: "done-publish",
        data: false,
    },
];
export default function CreateAnswerAction({ text, plainText }: {
    text: string,
    plainText?: string
}): ReactElement {
    const { Paths } = useRouting();
    const [isShowCreate, setIsShowCreate] = useState(false);
    const [createdId, setCreatedId] = useState<string | undefined>();

    const { data: tagsData } = useGetArticleTagsQuery();

    const [title, setTitle] = useState(plainText?.createBlurbSingleLine(30));
    const [body, setBody] = useState(text);

    const [shouldPublish, setShouldPublish] = useState(true);
    const [tagIds, setTagIds] = useState<string[]>();

    const [saveArticle] = useSaveArticleMutation();
    const [publish] = usePublishArticleMutation();

    useEffect(() => {
        setCreatedId(undefined);
        setShouldPublish(true);
        setTitle(plainText?.createBlurbSingleLine(30));
        setBody(text);
    }, [isShowCreate]);

    const onConfirm = async () => {
        const article = await saveArticle({
            variables: {
                article: {
                    title: title as string,
                    body,
                    tagIds,
                },
            },
        });
        const id = article.data?.saveArticle.id;
        setCreatedId(id);

        if (shouldPublish) {
            await publish({
                variables: {
                    id,
                    settings: {
                        publishDate: new Date(),
                    },
                },
            });
        }
    };

    return (
        <>

            <Confirm
                shouldShow={isShowCreate}
                onConfirm={!createdId ? onConfirm : undefined}
                size="lg"
                confirmText={!createdId ? "Save" : undefined}
                onHide={() => setIsShowCreate(false)}
                dialogClassName="mt-5"
            >
                {createdId ? (
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            Your answer has been created
                        </div>
                        <Link
                            to={Paths.ANSWERS_GET}
                            params={{ id: createdId as string }}
                            className="btn btn-primary d-block btn-sm"
                            onClick={() => setIsShowCreate(false)}
                            target="_blank"
                            rel="noreferer"
                        >
                            View Answer
                        </Link>
                    </div>
                ) : (
                    <div>
                        <h4 className="mb-3">
                            <EditableControl
                                type={ControlType.TEXT}
                                value={title ?? ""}
                                onChange={value => setTitle(value as string)}
                                isEditing
                            />
                        </h4>

                        <Editor
                            onChange={change => setBody(change)}
                            text={body}
                            className={`border ${Styles.editor}`}
                        />

                        {tagsData?.articleTags?.isNotEmpty && (
                            <div className="mt-3">
                                <Select
                                    isMulti
                                    placeholder="Tags.."
                                    onChange={options => setTagIds(options?.map(row => row.value))}
                                    options={tagsData.articleTags.map(tag => ({
                                        label: (
                                            <div>
                                                {tag.iconUrl ? <Avatar src={tag.iconUrl as string} variant="xs" /> : "#"}
                                                {tag.title}
                                            </div>
                                        ),
                                        value: tag.id,
                                    }))}
                                />
                                <small className="text-light mt-2">
                                    Which tags do you want to add to this answer?
                                </small>
                            </div>
                        )}

                        <div className="mt-3">
                            <Select
                                minRequired={1}
                                placeholder="Select if to publish"
                                onChange={option => setShouldPublish(option?.data ?? true)}
                                options={PUBLISH_OPTOIONS}
                                value={PUBLISH_OPTOIONS.find(value => value.data === shouldPublish)}
                            />
                            <small className="text-light mt-2">
                                Do you want to also publish the answer after creating or
                                just create the answer and allow you to manually publish
                                the answer later.
                            </small>
                        </div>

                    </div>
                )}

            </Confirm>
            <Dropdown.Item onClick={() => setIsShowCreate(true)} className="text-white">
                Create Answer
            </Dropdown.Item>
        </>
    );
}

CreateAnswerAction.defaultProps = {
    plainText: undefined,
};
